import { ImageLoader } from 'next/image';

export const srcLoader: ImageLoader = ({ src }) => {
	return src;
};

export default srcLoader;
